import { render } from "./CompanyMemo.vue?vue&type=template&id=33bcf433"
import script from "./CompanyMemo.vue?vue&type=script&lang=js"
export * from "./CompanyMemo.vue?vue&type=script&lang=js"

import "./CompanyMemo.vue?vue&type=style&index=0&id=33bcf433&lang=css"

import exportComponent from "/home/runner/work/origins-admin-v2/origins-admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__